import styled from '@emotion/styled';
import Image from 'next/image';
import { primary, blue, green, yellow, gray } from '@styles/Colors';

type HashTagColor = {
  color: string;
  background: string;
};

const BenefitCardContainer = styled.div`
  display: flex;
  width: 100%;
  min-width: 480px;
  max-width: 480px;
  height: 100%;
  min-height: 344px;
  max-height: 344px;
  padding-bottom: 0px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid #e2e2e2;

  img {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
`;

const BenefitImageWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
`;

const BenefitCardCotentWrapper = styled.div`
  background: ${gray.gray1};
  padding: 20px;
  width: 100%;
  height: 144px;
`;

const BenefitCardCotentHashTagWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const BenefitCardCotentHashTag = styled.span<{ hashTagColor: HashTagColor }>`
  display: flex;
  padding: 1px 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background-color: ${(props) => props.hashTagColor.background};
  color: ${(props) => props.hashTagColor.color};

  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.24px;
`;

const BenefitCardContentTitle = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.28px;
  padding-top: 8px;
  padding-bottom: 16px;
`;

const BenefitCardContentText = styled.p`
  color: ${primary.gray};

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.28px;
  white-space: pre-line;
`;

export const benefitHashTagColors: { [key: string]: HashTagColor } = {
  업무: {
    color: primary.blue,
    background: blue.blue1,
  },
  라이프: {
    color: green.green3,
    background: green.green1,
  },
  기타: {
    color: yellow.yellow1,
    background: yellow.yellow4,
  },
};

export const benefitHashTagList = Object.keys(benefitHashTagColors).map((name) => name);

export type Props = {
  readonly hashTags: string[];
  readonly title: string;
  readonly content: string;
  readonly image: {
    readonly src: string;
    readonly width: number;
    readonly height: number;
  };
};

export default function BenefitCard({ hashTags, title, content, image }: Props) {
  return (
    <>
      <BenefitCardContainer>
        <BenefitImageWrapper>
          <Image alt="benefit-image" {...image} />
        </BenefitImageWrapper>
        <BenefitCardCotentWrapper>
          <BenefitCardCotentHashTagWrapper>
            {hashTags.map((item, index) => (
              <BenefitCardCotentHashTag hashTagColor={benefitHashTagColors[item]} key={index}>
                #{item}
              </BenefitCardCotentHashTag>
            ))}
          </BenefitCardCotentHashTagWrapper>
          <BenefitCardContentTitle>{title}</BenefitCardContentTitle>
          <BenefitCardContentText>{content}</BenefitCardContentText>
        </BenefitCardCotentWrapper>
      </BenefitCardContainer>
    </>
  );
}
